/* eslint-disable */
import { ioteqNavigationItem } from '@tools/components/navigation';

export const defaultNavigation: ioteqNavigationItem[] = [];

export const navigationMenu = {
    trailer_systems: {
        id      : 'list',
        title   : 'Trailer Systems',
        type    : 'basic',
        icon    : 'mat_outline:list',
        link    : 'trailer-systems/list'
    },
    user_management: {
        id      : 'user-management',
        title   : 'User Management',
        type    : 'basic',
        icon    : 'heroicons_outline:users',
        link    : 'user-management'
    },
    user_notify: {
        id      : 'user-notify',
        title   : 'User Notify',
        type    : 'basic',
        icon    : 'heroicons_outline:bell',
        link    : 'notifications'
    },
    user_sys_assign: {
        id      : 'sys-assign',
        title   : 'System Administration',
        type    : 'basic',
        icon    : 'heroicons_outline:adjustments',
        link    : 'system-assignment'
    },
    bulletin_management: {
        id      : 'bulletin-management',
        title   : 'Bulletin Management',
        type    : 'basic',
        icon    : 'heroicons_outline:bookmark-alt',
        link    : 'bulletin-management'
    },
}